/**
 * Field renderer registry (Open/Closed — add new field types without editing FilterField).
 */
import MultiSelectField from './fields/MultiSelectField';
import SelectField from './fields/SelectField';
import StudentIdFilterField from './fields/StudentIdFilterField';
import TextWithSuggestionsField from './fields/TextWithSuggestionsField';
import DefaultTextField from './fields/DefaultTextField';

const FIELD_RENDERERS = [
  {
    matches: (field) =>
      field.name === 'veStudentId' || field.name === 'studentId',
    Component: StudentIdFilterField,
  },
  {
    matches: (field) => field.hasOptions && field.type === 'select' && field.multiSelect,
    Component: MultiSelectField,
  },
  {
    matches: (field) => field.hasOptions && field.type === 'select',
    Component: SelectField,
  },
  {
    matches: (field) => field.hasOptions && field.type === 'text',
    Component: TextWithSuggestionsField,
  },
];

/**
 * @param {object} field
 * @returns {React.ComponentType}
 */
export function resolveFilterFieldComponent(field) {
  const entry = FIELD_RENDERERS.find((r) => r.matches(field));
  return entry ? entry.Component : DefaultTextField;
}
